export const formatCurrency = (val) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(val);
};

// Note: Cette fonction génère un numéro temporaire
// Le vrai numéro séquentiel est généré côté serveur via getNextDocumentNumber
export const generateNumber = (type) => {
  const prefix = type === "quote" ? "DEV" : "FAC";
  const year = new Date().getFullYear();
  const month = String(new Date().getMonth() + 1).padStart(2, "0");
  return `${prefix}-${year}-${month}-TEMP`;
};

export const calculateTotals = (sections, globalSettings = {}) => {
  const defaultVat = globalSettings.defaultVat !== undefined ? Number(globalSettings.defaultVat) : 20;
  
  // On aplatit toutes les lignes pour utiliser reduce comme demandé
  const allItems = sections.flatMap(s => s.items || []);
  
  const totals = allItems.reduce((acc, item) => {
    // On force la conversion en nombre pour éviter le blocage à 0
    const price = parseFloat(String(item.price || 0).replace(',', '.')) || 0;
    const qty = parseFloat(String(item.qty || item.quantity || 0).replace(',', '.')) || 0;
    const lineHT = price * qty;
    
    const vatRate = item.vat !== undefined ? Number(item.vat) : defaultVat;
    const lineTVA = lineHT * (vatRate / 100);
    
    acc.subtotal += lineHT;
    acc.totalTva += lineTVA;
    return acc;
  }, { subtotal: 0, totalTva: 0 });

  return {
    rawTotalHT: round2(totals.subtotal),
    totalTVA: round2(totals.totalTva),
    totalTTC: round2(totals.subtotal + totals.totalTva)
  };
};

// Arrondi à 2 décimales (précis pour les montants)
export function round2(n) {
  return Math.round((parseFloat(n) + Number.EPSILON) * 100) / 100;
}

// Convertir un timestamp Firestore ou une date en objet Date
export const toDate = (timestamp) => {
  if (!timestamp) return new Date();
  if (timestamp.toDate) return timestamp.toDate();
  if (timestamp instanceof Date) return timestamp;
  return new Date(timestamp);
};

// Trier des documents par date de création (du plus récent au plus ancien)
export const sortDocumentsByDate = (docs) => {
  return docs.sort((a, b) => {
    const dateA = toDate(a.createdAt || a.date);
    const dateB = toDate(b.createdAt || b.date);
    return dateB - dateA;
  });
};

// Parser une valeur numérique avec support de la virgule française
export const parseNumber = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (!value || value === '') return defaultValue;
  const str = String(value).trim();
  if (str.endsWith(',') || str.endsWith('.')) return null;
  const normalized = str.replace(',', '.');
  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? defaultValue : parsed;
};
